<template>
  <figure>
    <h3 class="subtitle is-5">Subjects</h3>
    <ul>
      <li v-for="a in agg" :key="a.key">
        <b-checkbox v-model="selectedDevices" :native-value="a.key">
          <DeviceId :id="a.key" hide-link />: {{ a.count.toLocaleString() }}
        </b-checkbox>
      </li>
    </ul>
    <div v-if="selectedDevices.length > 0" class="buttons mt-4 is-centered">
      <b-button type="is-primary" @click="filter">
        Filter by {{ selectedDevices.length.toLocaleString() }}
        subject{{ selectedDevices.length === 1 ? '' : 's' }}
      </b-button>
    </div>
  </figure>
</template>

<script>
export default {
  emits: ['filter'],
  props: {
    agg: Array
  },
  data () {
    return {
      selectedDevices: []
    }
  },
  methods: {
    filter () {
      this.$store.commit('filters/setDevices', this.selectedDevices)
      this.$emit('filter')
    }
  }
}
</script>

<style lang="scss" scoped>
figure ul {
  column-count: 2;
}
</style>